export const comments_5618945 = {"data":{"data":[],"links":{}}}